import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AuthRoutes from "../auth/routes/auth.routes";
import { useSelector } from "react-redux";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import ClientRoutes from "../client/routes/client.routes";
import AdminRoutes from "../admin/routes/admin.routes";
import { useRoutes } from "react-router-dom";
import MainRoutes from "../main/routes/main.routes";
import AdminDashboard from "../../Admin/AdminDashboard";
import LanguageSync from "../../components/LanguageSync";
import LanguageRouter from "../../components/LanguageRouter";
import UserManagement from "../../Admin/AdminUserManagement";
import BusinessManagement from "../../Admin/AdminBusinessManagement";
import AllUsersPage from "../../Admin/UserManagement/AllUsers";
import LocalProfessionalsPage2 from "../../Admin/UserManagement/LocalProfessionalsPage";
import InternationalProfessionalsPage2 from "../../Admin/UserManagement/InternationalProfessionalsPage";
import VerificationRequestsPage from "../../Admin/UserManagement/VerificationRequestsPage";
import BusinessDirectory from "../../Admin/BUSINESS MANAGEMENT/BusinessDirectory";
import ServiceCategories from "../../Admin/BUSINESS MANAGEMENT/ServiceCategories";
import EmergencyServices from "../../Admin/BUSINESS MANAGEMENT/EmergencyServices";
import ServiceAreas from "../../Admin/BUSINESS MANAGEMENT/ServiceAreas";
import AllOrdersPage from "../../Admin/ORDER MANAGEMENT/AllOrders";
import PendingOrdersPage from "../../Admin/ORDER MANAGEMENT/PendingOrders";
import EmergencyRequestsPage from "../../Admin/ORDER MANAGEMENT/EmergencyRequests";
import QuotesPage from "../../Admin/ORDER MANAGEMENT/QuotesPage";
import TransactionsPage from "../../Admin/FINANCIAL MANAGEMENT/Transactions";
import RevenuePage from "../../Admin/FINANCIAL MANAGEMENT/Revenue";
import PayoutsPage from "../../Admin/FINANCIAL MANAGEMENT/Payouts";
import InvoicesPage from "../../Admin/FINANCIAL MANAGEMENT/invoices";
import ReviewsAndRatings from "../../Admin/Content Management/Rating";
import SupportTickets2 from "../../Admin/Content Management/SupportTickets";
import HelpCenter22 from "../../Admin/Content Management/help";
import Announcements from "../../Admin/Content Management/Announcements";
import BusinessAnalytics from "../../Admin/ANALYTICS/BusinessAnalytics";
import UserAnalytics from "../../Admin/ANALYTICS/UserAnalytics";
import GrowthMetrics from "../../Admin/ANALYTICS/GrowthMetricsDashboard";
import GeneralSettings from "../../Admin/General Settings/GeneralSettings";
import SecuritySettings from "../../Admin/General Settings/Security";
import SystemLogs from "../../Admin/General Settings/SystemLogs";
import SystemLogs2 from "../../Admin/General Settings/SystemLogs";
import { BsWhatsapp } from "react-icons/bs";
import WhatsAppIntegration from "../../Admin/WhatsApp Management/WhatsApp";
import ChatManagement from "../../Admin/WhatsApp Management/ChatManagement";
import CustomNotifications from "../../Admin/WhatsApp Management/CustomNotifications";
import ProfessionalForms from "../../Admin/FORM MANAGEMENT/ProfessionalForms";
import QuoteForms from "../../Admin/FORM MANAGEMENT/Quote Forms";
import QuotePricing from "../../Admin/SUBSCRIPTION & PRICING/QuotePricing";
import SubscriptionPlansadmin from "../../Admin/SUBSCRIPTION & PRICING/SubscriptionPlansManagement";
import RegionalPricing from "../../Admin/SUBSCRIPTION & PRICING/RegionalPricingManagement";
import PerformanceMetrics from "../../Admin/PROFESSIONAL SCORING/PerformanceMetrics";
import Rankings from "../../Admin/PROFESSIONAL SCORING/Rankings";
import Rankingsadmin from "../../Admin/PROFESSIONAL SCORING/Rankings";
import ScoringSettings from "../../Admin/PROFESSIONAL SCORING/ScoringSettings";
import PaymentMilestones from "../../Admin/MILESTONE MANAGEMENT/Milestones";
import CommissionSettings from "../../Admin/MILESTONE MANAGEMENT/CommissionSettings";
import DepositRules from "../../Admin/MILESTONE MANAGEMENT/DepositRules";
import TermsConditions from "../../Admin/CONTENT EDITOR/TermsEditor";
import NewsManagement from "../../Admin/CONTENT EDITOR/NewsManagement";
import MarketingPopups from "../../Admin/CONTENT EDITOR/MarketingPopups";
import RegionSettings from "../../Admin/INTERNATIONAL/RegionSettings";
import LanguageManager from "../../Admin/INTERNATIONAL/LanguageManager";
import CurrencySettings from "../../Admin/INTERNATIONAL/CurrencySettings";
import CategoryForms from "../../Admin/FORM MANAGEMENT/CategoryForms";
import ChatManagement2 from "../../Admin/chat/ChatManagement";
import AdminClientsDashboard from "../../Admin/CONTENT EDITOR/profiles";
import Favorites2 from "../../pages/Favorites";
import DynamicPage from "../../pages/DynamicPage";
import PageList from "../../pages/PageList";
import AppBackRoute from "./app.route";
import ProfessionalRoutes from "../professional/routes/professional.rotues";
import ClientProfile from "../client/components/ClientProfile1";
import MyProfile from "../professional/components/MyProfile";
import GlobalNotifications from "../../components/GlobalNotifications";
import WebSocketNotificationListener from "../../components/WebSocketNotificationListener";
import DisputeRequestsPage from "../../Admin/ORDER MANAGEMENT/DisputeRequestsPage";
import { RoleEnum } from "../shared";
import ClientInvoice from "../../pages/ClientInvoice";
import ProfessionalInvoice from "../../pages/ProfessionalInvoice";
import TrustpilotSettings from "../../Admin/SETTINGS/TrustpilotSettings";
import LocationManagement from "../../Admin/FORM MANAGEMENT/LocationManagement";
import ProfessionalMonitoring from "../../Admin/PROFESSIONAL SCORING/ProfessionalMonitoring";
import { SUPPORTED_LANGUAGES } from "../../utils/languageRouting";

const RoutesConfig = () => {
    // Generate language-prefixed auth routes
    const authRoutes = [
        { path: "/auth/*", element: <AuthRoutes /> },
    ];
    
    // Add language-prefixed versions of auth routes
    const languagePrefixedAuthRoutes: any[] = [];
    SUPPORTED_LANGUAGES.filter(lang => lang !== "en").forEach(lang => {
        languagePrefixedAuthRoutes.push({
            path: `/${lang}/auth/*`,
            element: <AuthRoutes />
        });
    });

    const routes = [
        { path: "*", element: <Navigate to="/" replace /> },
        {
            element: <PublicRoute />,
            children: [
                ...authRoutes,
                ...languagePrefixedAuthRoutes,
            ],
        },
        {
            element: <PrivateRoute />,
            children: [
                ...ClientRoutes,
                ...ProfessionalRoutes,
                ...AdminRoutes,
                { path: "/admin/dashboard", element: <AdminDashboard /> },
                { path: "/admin/usermanagement", element: <UserManagement /> },
                { path: "/admin/businessmanagement", element: <BusinessManagement /> },
                { path: "/admin/usermanagement/alluser", element: <AllUsersPage /> },
                { path: "/admin/usermanagement/localprofesionals", element: <LocalProfessionalsPage2 /> },
                { path: "/admin/usermanagement/internationalprofesionals", element: <InternationalProfessionalsPage2 /> },
                { path: "/admin/usermanagement/verificationrequests", element: <VerificationRequestsPage /> },
                { path: "/admin/businesses", element: <BusinessDirectory /> },
                { path: "/admin/categories", element: <ServiceCategories /> },
                { path: "/admin/emergency-services", element: <EmergencyServices /> },
                { path: "/admin/service-areas", element: <ServiceAreas /> },
                { path: "/admin/orders", element: <AllOrdersPage /> },
                { path: "/admin/orders/pending", element: <PendingOrdersPage /> },
                { path: "/admin/orders/emergency", element: <EmergencyRequestsPage /> },
                { path: "/admin/quotes", element: <QuotesPage /> },
                { path: "/admin/transactions", element: <TransactionsPage /> },
                { path: "/admin/revenue", element: <RevenuePage /> },
                { path: "/admin/payouts", element: <PayoutsPage /> },
                { path: "/admin/invoices", element: <InvoicesPage /> },
                { path: "/admin/reviews", element: <ReviewsAndRatings /> },
                { path: "/admin/support", element: <SupportTickets2 /> },
                { path: "/admin/help-center", element: <HelpCenter22 /> },
                { path: "/admin/announcements", element: <Announcements /> },
                { path: "/admin/analytics/business", element: <BusinessAnalytics /> },
                { path: "/admin/analytics/users", element: <UserAnalytics /> },
                { path: "/admin/analytics/growth", element: <GrowthMetrics /> },
                { path: "/admin/settings", element: <GeneralSettings /> },
                { path: "/admin/security", element: <SecuritySettings /> },
                { path: "/admin/logs", element: <SystemLogs2 /> },
                { path: "/admin/trustpilot", element: <TrustpilotSettings /> },
                { path: "/admin/tools/whatsapp", element: <WhatsAppIntegration /> },
                { path: "/admin/tools/chat", element: <ChatManagement /> },
                { path: "/admin/tools/notifications", element: <CustomNotifications /> },
                { path: "/admin/forms/categories", element: <CategoryForms /> },
                { path: "/admin/forms/professionals", element: <ProfessionalForms /> },
                { path: "/admin/forms/quotes", element: <QuoteForms /> },
                { path: "/admin/pricing/quotes", element: <QuotePricing /> },
                { path: "/admin/pricing/subscriptions", element: <SubscriptionPlansadmin /> },
                { path: "/admin/pricing/regions", element: <RegionalPricing /> },
                { path: "/admin/scoring/metrics", element: <PerformanceMetrics /> },
                { path: "/admin/scoring/rankings", element: <Rankingsadmin /> },
                { path: "/admin/scoring/settings", element: <ScoringSettings /> },
                { path: "/admin/scoring/monitoring", element: <ProfessionalMonitoring /> },
                { path: "/admin/milestones/payments", element: <PaymentMilestones /> },
                { path: "/admin/milestones/commission", element: <CommissionSettings /> },
                { path: "/admin/milestones/deposits", element: <DepositRules /> },
                { path: "/admin/editor/terms", element: <TermsConditions /> },
                { path: "/admin/editor/news", element: <NewsManagement /> },
                { path: "/admin/editor/marketing", element: <MarketingPopups /> },
                { path: "/admin/international/regions", element: <RegionSettings /> },
                { path: "/admin/international/languages", element: <LanguageManager /> },
                { path: "/admin/international/currencies", element: <CurrencySettings /> },
                { path: "/admin/analytics/chat", element: <ChatManagement2 /> },
                { path: "/admin/editprofile", element: <AdminClientsDashboard /> },
                { path: "/admin/favorites", element: <Favorites2 /> }, // Only one will be used; duplicate path
                { path: "/admin/dispute-requests", element: <DisputeRequestsPage /> },
                { path: "admin/locationmanagement", element: <LocationManagement /> },
            ],
        },
        ...AppBackRoute,
        ...MainRoutes,
        { path: "/pages", element: <PageList /> },
        // Dynamic page route - must be before the catch-all route
        { path: "/:url/*", element: <DynamicPage /> },

        // // ,
        // { path: "/Terms", element: <TermsPage /> },
        // { path: "/Cookie", element: <CookiesPolicyPage /> },
        // { path: "/projects", element: <ProjectsPage /> },
        // { path: "/internationalhompage", element: <ProHomepage /> },
        // { path: "/plumberregistration", element: <PlumberRegistration /> },
        // { path: "/plumberrequestform", element: <PlumberRequestForm /> },
        // { path: "/lawyerRequestForm", element: <LawyerRequestForm /> },
        // { path: "/plumberprofile", element: <PlumberProfile /> },
        // { path: "/professionalplumberprofile", element: <ProfessionalPlumberProfile /> },
        // { path: "/international-professionals", element: <InternationalProfessional /> },
        // { path: "/jobs", element: <InternationalProfessionalsPage /> },
        // { path: "/local-professionals", element: <LocalProfessionalsPage /> },
        // { path: "/professional-international", element: <InternationalProfessionalsProfile /> },
        // { path: "/walletd", element: <WalletPage /> },
        // { path: "/myprofile", element: <MyProfile /> },
        // { path: "/international_professional_registration", element: <InternationalProfessionalRegistration /> },
        // { path: "/progress", element: <ProgressDashboard /> },

        // { path: "/myoffers", element: <OffersDashboard /> },
        // { path: "/myproposals", element: <ProposalsDashboard /> },
        // { path: "/support", element: <SupportTickets /> },
        // { path: "/wallet", element: <WalletDashboard /> },
        // { path: "/withdrawalhistroy", element: <WithdrawHistory /> },
        // { path: "/profilesettings", element: <ProfileSettings /> },
        // { path: "/changepassword", element: <ChangePassword /> },
        // { path: "/DeleteAccount", element: <DeleteAccount /> },
        // { path: "/MessageAndVideoCall", element: <MessagesAndVideoCall /> },

        // { path: "/clients/settings", element: <ClientSettings /> },
        // { path: "/clients/progress", element: <ProgressPage /> },
        // { path: "/postajob", element: <PostJobPage /> },
        // { path: "/myjobs", element: <MyJobsPage /> },
        // { path: "/clients/myoffers", element: <MyOffersPage /> },
        // { path: "/clients/MessageAndVideoCall", element: <CMessagesAndVideoCall /> },
        // { path: "/clients/Wallet", element: <ClientWalletPage /> },
        // { path: "/clients/profilesettings", element: <ClientProfileSettings /> },
        // { path: "/clients/support", element: <ClientSupportTickets /> },
        // { path: "/profile-intro", element: <ClientProfileIntro /> },
        // { path: "/menu/contact", element: <ContactPage /> },
        // { path: "/invite", element: <InviteFriendsComponent /> },
        // { path: "/categories", element: <CategoriesAndLocationComponent /> },

    ];
    const routing = useRoutes(routes);
    return routing;
};

const AppRoutes = () => {
    const { isAuthenticated, rehydrated, user } = useSelector((state: any) => state.auth);
    if (!rehydrated) {
        return null;
    }
    return (
        <BrowserRouter>
            <LanguageSync />
            <LanguageRouter>
                <RoutesConfig />
                {isAuthenticated && (Number(user?.role?.id) === RoleEnum.professional || Number(user?.role?.id) === RoleEnum.internationl_professional )&& <GlobalNotifications />}
                {isAuthenticated && <WebSocketNotificationListener />}
            </LanguageRouter>
        </BrowserRouter>
    );

};

export default AppRoutes;
